import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigService } from './config.service';
import { SquidexApiService } from './squidex-api.service';

@NgModule({
  imports: [CommonModule],
})
export class SBPServicesModule {
  public static forRoot(environment: any): ModuleWithProviders<any> {
    return {
      ngModule: SBPServicesModule,
      providers: [
        ConfigService,
        SquidexApiService,
        {
          provide: 'environment',
          useValue: environment,
        },
      ],
    };
  }
}
